// extracted by mini-css-extract-plugin
export default {"whatsapp":"WmsbkE","facebook":"X890_J","twitter":"cLXjUK","pinterest":"LnEpSk"};